import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'

/**
 * Displays a small loading spinner inline (not an overlay) when open.
 *
 * Should only be used when a section of the page is loading that is not
 * critical to the operation of the rest of the page. For example, when
 * loading an integration (notifications) that is not required for the user to
 * interact with the rest of the page, or different sections of a dashboard.
 */
const PointPreloader = () => (
    <div className="point-preloader">
        <>
            <div className="overlay" />
            <img className="circle" src={ICONS.preloader_circle} alt="preloader" />
        </>
    </div>
)

export default PointPreloader
